import type { eventWithTime } from '@rrweb/types';
import { z } from 'zod';

export type { eventWithTime };

export const rrwebNetworkCallSchema = z.object({
  method: z.string(),
  url: z.string(),
  status: z.number().int(),
  duration: z.number().nonnegative(),
  requestBody: z.unknown().optional(),
  responseBody: z.unknown().optional(),
  requestHeaders: z.record(z.string(), z.string()).optional(),
  responseHeaders: z.record(z.string(), z.string()).optional(),
  timestamp: z.number().nonnegative(),
});

export type RrwebNetworkCall = z.infer<typeof rrwebNetworkCallSchema>;

export const RRWEB_URL_EVENT_TAG = 'url';

export const rrwebUrlPayloadSchema = z.object({
  href: z.string(),
});

export type RrwebExportJson = {
  meta: {
    tabId: string;
    exportedAt: string;
  };
  events: eventWithTime[];
  network: RrwebNetworkCall[];
};
